import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'
import upperFirst from 'lodash/upperFirst'
import { kebabCase } from 'lodash'

export class CommentActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'pinned': 'boolean',
    }

    static getLogDescriptionUpdated (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc('common.change-log.subject.some--target.comment', 1)}</b>`,
        }
        if (data.causer) {
            return i18n.t('common.change-log.someone-updated-something', interpolationParams)
        } else {
            return i18n.t('common.change-log.something-has-been-updated', interpolationParams)
        }
    }

    static showLogDetailsUpdated = false
}
